import AErrorBalloon from './index.vue';

AErrorBalloon.install = app => {
  app.component(AErrorBalloon.name, AErrorBalloon);
};

export default AErrorBalloon;
